import { fetchQuestions, fetchCategories } from './api';

const CATEGORY_IMAGES = ['credit-card', 'map', 'navigation', 'drink'];

export const getQuestions = async (search = '') => {
  return await fetchQuestions(encodeURIComponent(search));
}

export const getCategories = async (search = '') => {
  return await fetchCategories(encodeURIComponent(search));
}

export const getRootCategoryId = (categories, categoryId) => {
  const category = categories.find(cat => cat.id === categoryId);
  return category ? (category.parent_category ? getRootCategoryId(categories, category.parent_category) : category.id) : '';
}

export const getRootCategories = (categories) => {
  return categories.filter(cat => cat.parent_category === null).sort((a, b) => a.sort - b.sort);
}

export const getCategoryImage = (index) => {
  if (index < 0 || index >= CATEGORY_IMAGES.length) { return ''; }
  return CATEGORY_IMAGES[index];
}

export const getCategoriesEllipsis = (categories) => {
  return categories.map(category => category.name).join(', ');
}

export const getQuestionPermalink = (locale, question) => {
  const slug = (question.seo_title || question.question).toLowerCase().replace(/\s+/g, '-').replace(/[^\w\s-]/g, '');
  return `/${locale}/faq/${question.id}/${slug}/`;
}

export const getTextLink = (text) => {
  const link = text.match(/{{(.*?)}}/);
  return link ? link[1] : '';
}

export const getTextNoLink = (text) => {
  const parts = text.split(/{{(.*?)}}/);
  return parts.length > 1 ? [parts[0], parts[2]] : [text, ''];
}

export const isDesktop = () => {
  return window.innerWidth >= 992;
}